var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollectionBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 762,
    height: 836,
    viewBox: "0 0 762 836",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 762,
    height: 836,
    fill: "#ECEEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M776 228.5C754.779 278.75 707.308 361.336 678.993 408.981C675.447 414.949 671.128 420.721 667.822 426.767C662.602 436.314 658.945 450.959 660.293 461.263C663.443 485.344 696.312 506.5 720.522 517.845C737.613 525.854 752.508 536.98 771.523 542.081",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M766.5 126.5C739.097 191.71 658.076 349.258 621.512 411.089C616.932 418.833 611.354 426.323 607.085 434.17C600.345 446.559 595.623 465.564 597.363 478.936C601.431 510.186 643.876 537.641 675.14 552.363C697.21 562.756 739.445 588.381 764 595",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M763 12.5C722.276 109.52 632.766 300.027 578.427 392.019C571.622 403.54 563.332 414.684 556.988 426.358C546.971 444.791 539.953 473.066 542.54 492.962C548.584 539.456 611.663 580.303 658.125 602.208C690.923 617.67 727.009 643.152 763.5 653",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionBackground);
export default __webpack_public_path__ + "static/media/collection-background.c1b1a277849e95a80eca5c61ecc37dd2.svg";
export { ForwardRef as ReactComponent };